<!--
 * @Author:
 * @LastEditTime: 2024-07-08 18:20:52
 * @Description:
-->
<template>
  <CockpitDialog class="cameraPicture" title="作业态势感知" @close="close">
    <div class="w-full h-6/7" v-loading="loading">
      <YSPlayer
        v-if="codes.length"
        :code="codes"
        :pIid="deviceList[0] ? deviceList[0].pIid : ''"
        class="w-full h-full"
      ></YSPlayer>
    </div>
    <el-pagination
      background
      :current-page.sync="pagePart.pageNo"
      :page-size.sync="pagePart.pageSize"
      @current-change="getCameraList"
      layout="slot, prev, pager, next"
      :total="pagePart.total"
      class="text-center mt-20px"
    >
      <template>
        <span class="text-white-60 ">共</span>
        <span class="text-[#FBAF3D]">{{ Math.ceil(pagePart.total / 4.0) }}</span>
        <span class="text-white-60  mr-10px">页</span>
      </template>
    </el-pagination>
  </CockpitDialog>
</template>

<script>
// apis
import { IOTDeviceApi } from '@wiz-api/iot-device-management'

//
const iotDeviceApi = new IOTDeviceApi()

// components
const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}
const YSPlayer = () => {
  return import('../components/video/YSPlayer/multipleVideo')
}
export default {
  name: 'WorkSituationalAwareness',
  components: {
    CockpitDialog,
    YSPlayer,
  },
  data() {
    return {
      loading: false,
      pagePart: {
        total: 0,
        pageNo: 1,
        pageSize: 4,
      },
      deviceList: [],
      codes: [],
    }
  },
  created() {
    this.getCameraList()
  },
  methods: {
    close() {
      this.$emit('refresh', false)
    },
    async getCameraList() {
      this.loading = true
      const [err, res] = await iotDeviceApi.getDeviceWithDetailPageList({
        skipCount: (this.pagePart.pageNo - 1) * 4,
        maxResultCount: 4,
      })
      if (res && !err) {
        this.deviceList = res.items
        this.codes = res.items.map((item) => item.code)
        this.pagePart.total = res.totalCount > 20 ? 20 : res.totalCount
      }
      this.loading = false
    },
  },
}
</script>
<style lang="scss" scoped>
.cameraPicture {
  left: 520px;
  top: 200px;
}
.text-white-60 {
  color: white;
  opacity: 0.6;
}
</style>
